export default {
  title: "Archivos"
  , form: {
    descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
    , tipo: {
      label: "Tipo"
      , th: "Tipo"
    }
    , subtipo: {
      label: "Sub Tipo"
      , th: "Sub Tipo"
    }
  }
  , errors: {
    BD3002: { text: "Ocurrió un error en el catálogo de Archivos" }
    , WS3002: { text: "Ocurrió un error en el catálogo de Archivos" }
    , JS3002: { text: "Ocurrió un error en el catálogo de Archivos" }
    , CR3002: { text: "Ocurrió un error en el catálogo de Archivos" }
    , UK_Archivo: { text: "Ya existe un registro con el mismo código" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/generales/archivos.js